export default {
  MuiDialogContent: {
    root: {
      padding: 32,
    },
  },
};
